// Ícones do menu lateral e da barra superior: uma família só (Phosphor, traço duotone).
// Trocar o ícone de uma tela é mexer aqui — MainListItems.js e index.js só leem este mapa.
import React from "react";
import {
  PiWhatsappLogoDuotone,
  PiAddressBookDuotone,
  PiKanbanDuotone,
  PiChatsCircleDuotone,
  PiCalendarCheckDuotone,
  PiLightningDuotone,
  PiTagDuotone,
  PiChartPieSliceDuotone,
  PiSquaresFourDuotone,
  PiPulseDuotone,
  PiBinocularsDuotone,
  PiChartBarDuotone,
  PiStarDuotone,
  PiWalletDuotone,
  PiPhoneCallDuotone,
  PiMegaphoneDuotone,
  PiListBulletsDuotone,
  PiUsersThreeDuotone,
  PiFolderOpenDuotone,
  PiSlidersHorizontalDuotone,
  PiReceiptDuotone,
  PiClockCountdownDuotone,
  PiCurrencyCircleDollarDuotone,
  PiWarningDuotone,
  PiClipboardTextDuotone,
  PiWifiHighDuotone,
  PiRobotDuotone,
  PiCakeDuotone,
  PiTreeStructureDuotone,
  PiQuotesDuotone,
  PiSparkleDuotone,
  PiBroadcastDuotone,
  PiPlugsConnectedDuotone,
  PiCodeDuotone,
  PiPuzzlePieceDuotone,
  PiChatCenteredTextDuotone,
  PiGearSixDuotone,
  PiGraduationCapDuotone,
  PiQueueDuotone,
  PiUsersDuotone,
  PiCreditCardDuotone,
  PiLifebuoyDuotone,
  PiBuildingsDuotone,
  PiBankDuotone,
  PiDevicesDuotone,
  PiMegaphoneSimpleDuotone,
  PiBrainDuotone,
  PiHardDrivesDuotone,
  PiMagnifyingGlass,
  PiCaretDown,
  PiCaretLeft,
  PiCaretRight,
  PiList,
  PiGlobeHemisphereWest,
  PiMoon,
  PiSun,
  PiArrowsClockwise,
  PiDotsThree,
  PiUser,
  PiSignOut,
  PiShieldCheck,
  PiSpeakerSlash,
} from "react-icons/pi";

// Chave = rota (itens) ou id do grupo (grupos do menu)
export const MENU_ICONS = {
  // Atendimento
  "/tickets": PiWhatsappLogoDuotone,
  "/contacts": PiAddressBookDuotone,
  "/kanban": PiKanbanDuotone,
  "/chats": PiChatsCircleDuotone,
  "/schedules": PiCalendarCheckDuotone,
  "/quick-messages": PiLightningDuotone,
  "/tags": PiTagDuotone,
  // Gestão
  management: PiChartPieSliceDuotone,
  "/": PiSquaresFourDuotone,
  "/moments": PiPulseDuotone,
  "/supervision": PiBinocularsDuotone,
  "/reports": PiChartBarDuotone,
  "/attendance-insights": PiChartPieSliceDuotone,
  "/ratings": PiStarDuotone,
  "/wallets": PiWalletDuotone,
  "/call-historicals": PiPhoneCallDuotone,
  // Campanhas
  campaigns: PiMegaphoneDuotone,
  "/campaigns": PiListBulletsDuotone,
  "/contact-lists": PiUsersThreeDuotone,
  "/files": PiFolderOpenDuotone,
  "/campaigns-config": PiSlidersHorizontalDuotone,
  // Cobrança & Provedor
  billing: PiReceiptDuotone,
  "/billing-rules": PiClockCountdownDuotone,
  "/invoice-campaigns": PiCurrencyCircleDollarDuotone,
  "/network-alerts": PiWarningDuotone,
  "/erp-writeback": PiClipboardTextDuotone,
  "/hotspot": PiWifiHighDuotone,
  // Automação
  automation: PiRobotDuotone,
  "/birthday-settings": PiCakeDuotone,
  "/flowbuilders": PiTreeStructureDuotone,
  "/phrase-lists": PiQuotesDuotone,
  "/prompts": PiSparkleDuotone,
  "/ai-learning": PiGraduationCapDuotone,
  // Canais e API
  channels: PiBroadcastDuotone,
  "/connections": PiPlugsConnectedDuotone,
  "/messages-api": PiCodeDuotone,
  "/queue-integration": PiPuzzlePieceDuotone,
  "/meta-templates": PiChatCenteredTextDuotone,
  // Configurações
  config: PiGearSixDuotone,
  "/queues": PiQueueDuotone,
  "/users": PiUsersDuotone,
  "/financeiro": PiCreditCardDuotone,
  "/settings": PiSlidersHorizontalDuotone,
  // Ajuda
  "/helps": PiLifebuoyDuotone,
  // Plataforma
  "/companies": PiBuildingsDuotone,
  "/reseller-finance": PiBankDuotone,
  "/allConnections": PiDevicesDuotone,
  "/announcements": PiMegaphoneSimpleDuotone,
  "/ai-platform": PiBrainDuotone,
  "/system-resources": PiHardDrivesDuotone,
};

// Ícones de interface (traço simples: ficam ao lado de texto e em botões pequenos)
export const UI_ICONS = {
  search: PiMagnifyingGlass,
  caretDown: PiCaretDown,
  caretLeft: PiCaretLeft,
  caretRight: PiCaretRight,
  menu: PiList,
  language: PiGlobeHemisphereWest,
  moon: PiMoon,
  sun: PiSun,
  refresh: PiArrowsClockwise,
  more: PiDotsThree,
  user: PiUser,
  signOut: PiSignOut,
  shield: PiShieldCheck,
  muted: PiSpeakerSlash,
};

// <MenuIcon name="/tickets" /> — ícone desconhecido não quebra o menu
export const MenuIcon = ({ name }) => {
  const Icon = MENU_ICONS[name];
  return Icon ? <Icon aria-hidden="true" /> : null;
};
